var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setContext } from '@apollo/client/link/context';
/**
 * Fetches an access token and includes it in the authorization header for each outgoing request
 */
export const createAuthLink = (getAccessTokenSilently, logout) => {
    return setContext((_, { headers }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const token = yield getAccessTokenSilently();
            return {
                headers: Object.assign(Object.assign({}, headers), { authorization: `Bearer ${token}` }),
            };
        }
        catch (e) {
            // `getAccessTokenSilently` is called on every gql request if a user was
            // previously authenticated, but it can fail if there is an issue with the
            // refresh tokens. When that happens, sign the user out so that they can fully re-authenticate.
            logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            });
        }
    }));
};
